import { Link } from "react-router-dom";
import { Wrapper } from "./styles/ErrorStyle";
import { ReadError } from "../assets/images";

const Error = (props) => {
    return (
       <Wrapper className="full-page">
        <div>
            <ReadError className="error-img"/>
            <h3>Page Not Found</h3>
            <p>We can't seem to find the page you're looking for</p>
            <Link to="/">Back Home</Link>
        </div>
       </Wrapper>
    )
};
export default Error;